import { INotification } from 'shared/types/features';
import { TApplicationState } from 'shared/types/redux';

export const selectNotifications = (state: TApplicationState): INotification[] => {
  return state.notifications.list;
};
